import React, { useState } from "react";
import Adminhomemenu from "../Menus/Adminhomemenu";
//import Clienthomemenu from "../Menus/Clienthomemenu";

const Setftestexammodule = ({ questions }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  if (!questions || questions.length === 0) {
    return (
      <>
        <Adminhomemenu title="EasyITI" testhistory="testhistory" />
        <div
        className="container"
        style={{
          paddingTop: "90px",
          height: "auto",
        }}
      >
          <h5>No questions found</h5>
        </div>
      </>
    );
  }

  const currentQ = questions[currentIndex];

  return (
    <>
      <Adminhomemenu title="EasyITI" testhistory="testhistory" />

      {/* ===== QUESTION NUMBER BAR ===== */}
      {/* <div className="container mt-2" style={{ height: "auto" ,padding:"50px"}}>
        <div className="d-flex flex-wrap gap-1">
          {questions.map((_, i) => (
            <button
              key={i}
              className={`btn btn-sm ${
                i === currentIndex ? "btn-primary" : "btn-outline-secondary"
              }`}
              onClick={() => setCurrentIndex(i)}
            >
              {i + 1}
            </button>
          ))}
        </div>
      </div> */}

      {/* ===== MAIN CONTENT ===== */}
      <div
        className="container"
        style={{
          paddingTop: "90px",
          height: "auto",
          alignContent:"center"
        }}
      >
        <div
          className="card w-100 shadow"
          style={{ maxWidth: 900 }}
        >
          <div className="card-header bg-dark text-white py-2">
            Question {currentIndex + 1} / {questions.length}
          </div>

          <div
            className="card-body"
            style={{
              overflowY: "auto",
              
            }}
          >
            <h5 className="mb-3">{currentQ.QUESTION}</h5>

            {["A", "B", "C", "D"].map((opt, i) => (
              <div
                key={opt}
                className={`border p-2 rounded mb-2 ${
                  opt === currentQ.RIGHT_ANS
                    ? "bg-success text-white"
                    : ""
                }`}
              >
                {opt}. {currentQ[`OPT${i + 1}`]}
              </div>
            ))}

            <div className="alert alert-success py-2 mt-3">
              ✅ <b>Correct Answer :</b> {currentQ.RIGHT_ANS}
            </div>
          </div>

          {/* ===== FOOTER ===== */}
          <div className="card-footer py-2 d-flex justify-content-between">
            <button
              className="btn btn-sm btn-secondary"
              disabled={currentIndex === 0}
              onClick={() => setCurrentIndex((p) => p - 1)}
            >
              ← Previous
            </button>

            <button
              className="btn btn-sm btn-primary"
              disabled={currentIndex === questions.length - 1}
              onClick={() => setCurrentIndex((p) => p + 1)}
            >
              Next →
            </button>
          </div>
        </div>
      </div>
      {/* ===== SCROLLBAR (RANGE SLIDER) ===== */}
      <div className="container mt-3">
        <input
          type="range"
          className="form-range"
          min="0"
          max={questions.length - 1}
          value={currentIndex}
          onChange={(e) => setCurrentIndex(Number(e.target.value))}
        />

        <div className="text-center fw-bold">
          Question {currentIndex + 1} of {questions.length}
        </div>
      </div>
    </>
  );
};

export default Setftestexammodule;
